import type { RestoreWizardConfig } from '../types'

export const CI_WIZARD_CONFIG: RestoreWizardConfig = {
  kind: 'CI_DEPLOYMENT',
  kindLabel: 'CI & Deployment Restore',
  unitIds: { select: 'ci-wz-1', repositories: 'ci-wz-2', targets: 'ci-wz-3', plan: 'ci-wz-4', order: 'ci-wz-5' },
  targetScopeForm: 'REPOSITORIES',
  singleRef: false,
}
